import type { GroupedItems } from './aisleGrouping'

type ShareableItem = {
  name:      string
  qtyLabel?: string | null
}

export function buildShareText<T extends ShareableItem>(grouped: GroupedItems<T>): string {
  const lines: string[] = ['Shopping list:', '']
  for (const { aisle, items } of grouped) {
    lines.push(`${aisle}:`)
    for (const item of items) {
      const qty = item.qtyLabel ? ` (${item.qtyLabel})` : ''
      lines.push(`  • ${item.name}${qty}`)
    }
    lines.push('')
  }
  lines.push('— from Pantry')
  return lines.join('\n')
}

type ShareResult = {
  ok:     boolean
  method: 'share' | 'clipboard' | 'cancelled' | 'failed'
}

export async function shareList<T extends ShareableItem>(
  grouped: GroupedItems<T>,
): Promise<ShareResult> {
  const text = buildShareText(grouped)

  if (typeof navigator !== 'undefined' && 'share' in navigator) {
    try {
      await navigator.share({ title: 'Shopping list', text })
      return { ok: true, method: 'share' }
    } catch (err) {
      if ((err as Error)?.name === 'AbortError') return { ok: false, method: 'cancelled' }
    }
  }

  try {
    await navigator.clipboard.writeText(text)
    return { ok: true, method: 'clipboard' }
  } catch {
    return { ok: false, method: 'failed' }
  }
}
